"use client";

import { useQuery } from "@tanstack/react-query";

export interface KalshiExchangeStatus {
  exchangeActive: boolean;
  tradingActive: boolean;
  fetchedAt: number;
}

async function fetchExchangeStatus(): Promise<KalshiExchangeStatus> {
  const res = await fetch("/api/markets/kalshi/exchange-status");
  if (!res.ok) return { exchangeActive: true, tradingActive: true, fetchedAt: 0 };
  return res.json();
}

/**
 * Single deduped query for the Kalshi exchange/trading status. Polled every
 * minute. Use to render a "Kalshi closed" banner and disable trade buttons
 * during scheduled maintenance windows or unscheduled outages.
 */
export function useKalshiExchangeStatus(enabled = true) {
  return useQuery<KalshiExchangeStatus>({
    queryKey: ["kalshi", "exchange-status"],
    queryFn: fetchExchangeStatus,
    enabled,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    staleTime: 45_000,
    gcTime: 5 * 60 * 1000,
    initialData: { exchangeActive: true, tradingActive: true, fetchedAt: 0 },
  });
}
